import ContainerCustom from "../../../Components/ContainerCustom";
import Table from "../../../Components/Table/Table";
import TableButton from "../../../Components/Buttons/TableButton";
import StatusColorful from "../../../Components/Table/Components/StatusColorful";
import { useState } from "react";

export default function BlogsList() {
  const [activeFilter, setActiveFilter] = useState([true, true, true]);

  return (
    <>
      <ContainerCustom
        header="لیست بلاگ‌ها"
        headSVG="archive"
        colorfulFilterOptions={[
          {
            SVGName: "star",
            text: "عمومی",
            className: "w-fit",
            color: "blue",
          },
          {
            SVGName: "star",
            text: "آموزش بازار کریپتو",
            className: "w-fit",
            color: "blue",
          },
        ]}
        activeFilter={activeFilter}
        setActiveFilter={setActiveFilter}
      >
        <Table
          showEmptyState
          columns={[
            { key: "uuid", label: "کد بلاگ" },
            {
              key: "category",
              label: "دسته بلاگ",
              render: (value) =>
                value === "general" ? (
                  <StatusColorful
                    SVGName="star"
                    text="عمومی"
                    className="w-fit"
                    color="blue"
                  />
                ) : value === "crypto" ? (
                  <StatusColorful
                    SVGName="star"
                    text="آموزش بازار کریپتو"
                    className="w-fit"
                    color="blue"
                  />
                ) : (
                  ""
                ),
            },
            { key: "title", label: "عنوان بلاگ" },
            {
              key: "detail",
              label: "جزئیات",
              render: (value, row) => (
                <TableButton
                  text="مشاهده"
                  href=""
                  // onClick={() => {window.location.href = `/rules/rule-info`}}
                  className="!py-1 !px-2 !rounded-md bg-zi-bg1-light dark:bg-zi-bg1-dark text-zi-text-light dark:text-zi-text-dark hocus:ring-1 hocus:ring-inset hocus:ring-zi-border-dark"
                />
              ),
            },
          ]}
          data={[
            {
              uuid: "973017",
              category: "general",
              title: "پراپ فرم پراپاچینو چیست و چه مزایایی نسبت به رقبا دارد",
              detail: "",
            },
            {
              uuid: "973017",
              category: "crypto",
              title: "اولین گام برای تبدیل شدن به تریدر حرفه‌ای",
              detail: "",
            },
          ]}
        />
      </ContainerCustom>
    </>
  );
}
